/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Deactivate_Warning2Inputs */

const en_settings_reportingapikeys_deactivate_warning2 = /** @type {(inputs: Settings_Reportingapikeys_Deactivate_Warning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deactivating takes effect immediately. API requests using this key will fail. The key can only be restored by regenerating it under the same name, which produces a new key.`)
};

/**
* | output |
* | --- |
* | "Deactivating takes effect immediately. API requests using this key will fail. The key can only be restored by regenerating it under the same name, which prod..." |
*
* @param {Settings_Reportingapikeys_Deactivate_Warning2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_deactivate_warning2 = /** @type {((inputs?: Settings_Reportingapikeys_Deactivate_Warning2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Deactivate_Warning2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_deactivate_warning2(inputs)
});
export { settings_reportingapikeys_deactivate_warning2 as "settings_reportingApiKeys_deactivate_warning" }